import { render, staticRenderFns } from "./universalCard.vue?vue&type=template&id=08e83c7e&scoped=true"
import script from "./universalCard.vue?vue&type=script&lang=js"
export * from "./universalCard.vue?vue&type=script&lang=js"
import style0 from "./universalCard.vue?vue&type=style&index=0&id=08e83c7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e83c7e",
  null
  
)

export default component.exports